
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

// @ts-ignore
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/php/php.js";

import * as n from "@/types/notifications";

import TroubleshootingModal from "./TroubleshootingModal.vue";
import CopyButton from "@/components/Reusable/CopyButton.vue";
import Icon from "@/components/UI/Icon.vue";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import clipboardCopy from "clipboard-copy";
import StackTrace from "@/components/Notifications/Types/Util/StackTrace.vue";

@Component({
  components: {
    Icon,
    codemirror,
    TroubleshootingModal,
    CopyButton,
    StackTrace
  }
})
export default class InternalServerError extends Vue {
  @Prop()
  value!: n.InternalServerErrorNotification;

  get troubleShootingModalOptions() {
    return { title: "Internal Server Error", tabTitle: "Stack Trace" };
  }

  get valueForClipboard(): string | undefined {
    return jsonStringifyOrUndefined(this.value);
  }

  moreInfoDialogOpen = false;

  get forcePersistentDialog() {
    return this.value.keepOpen ?? false;
  }

  mounted() {
    this.moreInfoDialogOpen = this.forcePersistentDialog;
  }

  setMoreInfoDialogOpen(open: boolean) {
    this.moreInfoDialogOpen = open;
  }

  get errorMessage(): string | undefined {
    return this.value.errorDetails?.message || this.value.errorMessage;
  }

  getSnippetFromTrace(trace: n.InternalServerErrorDetailsTrace) {
    return Object.values(trace.snippet).join("");
  }

  onCmReady(cm: any, trace: n.InternalServerErrorDetailsTrace) {
    cm.addLineClass(
      Math.max(1, trace.line - trace.startingLine),
      "wrap",
      "breakdance-codemirror-errorneous-line"
    );
  }

  copyErrorDetailsToClipboard() {
    const clip = jsonStringifyOrUndefined(this.value);
    if (clip) {
      clipboardCopy(clip);
    }
  }

  codemirrorOptions(trace: n.InternalServerErrorDetailsTrace) {
    return {
      tabSize: 4,
      mode: `text/x-php`,
      theme: "darcula",
      lineNumbers: true,
      firstLineNumber: trace.startingLine,
      lineWrapping: true,
      readOnly: true,
      scrollbarStyle: null,
      viewportMargin: Infinity
    };
  }
}
